import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  ad: null,
  ads: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
